import { OfbizForm, OfbizList } from '@urbannex/ofbiz-forms';
import { ConfigOptions, getColumnFieldTitles, getFields } from '@urbannex/view-containers';
import { PART_FORMS } from './forms';
import { NbMenuItem } from '@nebular/theme';

export const crmOptions:ConfigOptions = {
    name: '',
    title: '',
    listForm: new OfbizList({
        fieldFormName:"ListCustomers",
        fieldFormLocation:"local",
        fieldFormFields:getFields("ListCustomers",PART_FORMS),
        listFormName:"ListCustomers",
        entityName:"WebSite",
        listFormLocation:"component://kwikstore/widget/PartyForms.xml",
        columnFields:getFields("ListCustomers",PART_FORMS),
        columnFieldTitles: getColumnFieldTitles("ListCustomers",PART_FORMS),
        remoteFormData: {
            formData: {
                formName: 'ListCustomers',
                formLocation: 'component://kwikstore/widget/PartyForms.xml',
                listType: '',
                entityName: '',
                viewIndex: 0,
                viewSize: 20
            }
        },
        endPoint:"listFindWebSite",
        listType:'grid',
        emptyListMessage:"",
        viewIndex:1,
        findParameters:[
            {"noConditionFind":"Y"},
            {"roleTypeId":"CUSTOMER"},
            {"productStoreId":""}
          ],
    }),
    findForm: new OfbizForm,
    addForm: new OfbizForm,
    actions: [],
    settings: []
}

export const baseMenuItems:NbMenuItem[] = [
    {title:"Customer Relationship Management",group:true},
    {title:"List Customers",icon:"list-outline",link:"/admin/crm/customers"},
    {title:"New Customer",icon:"plus-outline"},
  ]